import { ArrowRight, UtensilsCrossed, EyeOff } from "lucide-react";
import { ReorderableList } from "./ReorderableList";

const slugOf = (c) => c.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const Tile = ({ c, list, onOpen, handle }) => {
  const cover = list.find((i) => i.image)?.image;
  const hidden = list.filter((i) => i.is_published === false).length;
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-black/5 bg-white shadow-sm hover:shadow-lg transition-shadow duration-200">
      <div className="absolute top-2 left-2 z-10">{handle}</div>
      <button
        type="button"
        onClick={() => onOpen(c)}
        data-testid={`admin-menu-category-tile-${slugOf(c)}`}
        className="block w-full text-left focus:outline-none focus:ring-2 focus:ring-brand-teal/40"
      >
        <div className="aspect-[16/9] bg-brand-cream overflow-hidden">
          {cover ? (
            <img src={cover} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          ) : (
            <div className="h-full w-full flex items-center justify-center text-brand-charcoal/25">
              <UtensilsCrossed className="h-8 w-8" />
            </div>
          )}
        </div>
        <div className="p-3.5 flex items-end justify-between gap-2">
          <div className="min-w-0">
            <p className="font-display font-black text-[15px] leading-tight text-brand-charcoal truncate">{c}</p>
            <p className="mt-1 text-[11.5px] text-brand-charcoal/55">
              {list.length} item{list.length === 1 ? "" : "s"}
              {hidden > 0 && (
                <span className="ml-1.5 inline-flex items-center gap-1 text-brand-gold-dark">
                  <EyeOff className="h-3 w-3" /> {hidden} hidden
                </span>
              )}
            </p>
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-brand-charcoal/30 group-hover:text-brand-teal group-hover:translate-x-0.5 transition-[color,transform]" />
        </div>
      </button>
    </div>
  );
};

// Admin Menu landing: one draggable tile per category; tap to open its items.
export const MenuCategoryTiles = ({ categories, items, onOpen, onReorder }) => (
  <div data-testid="admin-menu-category-tiles">
    <p className="mb-2 text-[11.5px] text-brand-charcoal/55">Drag the grip on a tile to change the order customers see.</p>
    <ReorderableList ids={categories} onReorder={onReorder} grid testid="admin-menu-category" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {(c, handle) => <Tile c={c} list={items.filter((i) => i.category === c)} onOpen={onOpen} handle={handle} />}
    </ReorderableList>
  </div>
);
